import request from '@/utils/request'

export function getRecommendHallList(params = {}) {
  return request.get('/ancestral/admin/recommend/halls', params)
}

export function saveRecommendHall(data) {
  return request.post('/ancestral/admin/recommend/halls/save', data)
}
